import React from 'react';
import { Button, Box, Tooltip } from '@mui/material';
import { useLanguage } from 'Utils/Translation/LanguageContext';
import TranslateIcon from '@mui/icons-material/Translate';
import { useIsMobile } from 'hooks/useMedia';

const LanguageSelector = () => {
    const { setLanguage } = useLanguage();

    const revertToEnglish = () => {
        setLanguage('en');
    };

    const isMobile = useIsMobile();
    const buttonColor = isMobile ? 'black' : 'white';
    const borderColor = isMobile ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.5)';
    const hoverBorderColor = isMobile ? 'black' : 'white';
    const hoverBackgroundColor = isMobile ? 'rgba(0, 0, 0, 0.04)' : 'transparent';

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title="Click to revert to English">
                <Button
                    onClick={revertToEnglish}
                    sx={{ color: buttonColor, borderColor: borderColor, '&:hover': { borderColor: hoverBorderColor, backgroundColor: hoverBackgroundColor } }}
                    variant="outlined"
                >
                    <TranslateIcon sx={{ color: buttonColor, mr: 1 }} /> Revert to English
                </Button>
            </Tooltip>
        </Box>
    );
};

export default LanguageSelector;



// Old dropdown:

// import React from 'react';
// import { Select, MenuItem, FormControl, SelectChangeEvent, Box } from '@mui/material';
// import { useLanguage } from 'Utils/Translation/LanguageContext';
// import TranslateIcon from '@mui/icons-material/Translate';

// const languageOptions = [
//   { code: 'en', name: 'English' },
//   { code: 'ja', name: '日本語' },
// ];

// const LanguageSelector = () => {
//   const { language, setLanguage } = useLanguage();

//   const handleChange = (event: SelectChangeEvent<string>) => {
//     setLanguage(event.target.value);
//   };

//   return (
//     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//       <TranslateIcon sx={{ color: 'white', mr: 1 }} />
      
//       <FormControl
//         size="small"
//         sx={{ minWidth: 10 }}
//       >
//         <Select
//           value={language}
//           onChange={handleChange}
//           MenuProps={{
//             disableScrollLock: true,
//             sx: {
//               '& .MuiPaper-root': {
//                 minWidth: 10,
//               },
//             },
//           }}
//           sx={{
//             color: 'white',
//             '.MuiOutlinedInput-notchedOutline': {
//               borderColor: 'rgba(255, 255, 255, 0.5)',
//             },
//             '&:hover .MuiOutlinedInput-notchedOutline': {
//               borderColor: 'white',
//             },
//             '.MuiSvgIcon-root': {
//               color: 'white',
//             },
//             height: '40px',
//             boxShadow: 'none',
//             '.MuiSelect-select': { paddingRight: '24px' },
//           }}
//         >
//           {languageOptions.map((option) => (
//             <MenuItem key={option.code} value={option.code}>
//               {option.name}
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl>
//     </Box>
//   );
// };

// export default LanguageSelector;